import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '@standardnotes/utils';
import Icon from '../Icon/Icon';
const ClearInputButton = ({ className, ...props }) => {
    return (_jsx("button", { className: classNames('flex cursor-pointer border-0 bg-transparent p-0', className), ...props, children: _jsx(Icon, { type: "clear-circle-filled", className: "text-neutral" }) }));
};
export default ClearInputButton;
